import { Slider, SliderProps, rem } from '@mantine/core'

export const CompactSlider = (props: SliderProps) => {
  return (
    <Slider
      size="xs"
      styles={(theme) => ({
        label: {
          fontSize: rem(11),
          fontWeight: 700,
          top: '-30px',
          backgroundColor: 'transparent',
          color: theme.colors.dark[5]
        },
        markLabel: {
          fontSize: rem(11)
        }
      })}
      labelAlwaysOn
      {...props}
    />
  )
}
